import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import api from "../utilis/api";
import axios from "axios";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function Packages() {
  const [loading, setLoading] = useState(null);
  const navigate = useNavigate();

  const { token } = useSelector((state) => state.auth);

  const STRIPE_PRICE_IDS = {
    monthly: "price_1TMBLp16booVXHu6Ya9MUeuA",
    yearly: "price_1TMBML16booVXHu6mWO5XSxx",
    // Live Key
    // monthly: "price_1TLq02IdDYF1KaufYbynIvZl",
    // yearly: "price_1TLq0dIdDYF1KaufyVPlUhHa",
  };

  const handleSubscribe = async (planId) => {
    if (!token) {
      alert("Please login first to subscribe!");
      navigate("/");
      return;
    }
    console.log(planId);
    if (planId !== "monthly" && planId !== "yearly") {
      alert("To book lessons or bundles, please go to the booking page.");
      return;
    }

    const priceId = STRIPE_PRICE_IDS[planId];

    if (!priceId || priceId.includes("here")) {
      alert("Price ID missing! Add real Stripe Price IDs.");
      return;
    }

    setLoading(planId);

    try {
      const res = await api.post(
        "payments/create-checkout-session",
        {
          priceId,
          planType: planId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );

      const data = res.data;

      console.log("Server response:", data);

      if (res.status !== 200) {
        alert(`Error: ${data.message || "Server error"}`);
        return;
      }

      if (data.url) {
        window.location.href = data.url;
      } else {
        alert("No checkout URL received!");
      }
    } catch (err) {
      console.error("Stripe error:", err);
      alert(`Something went wrong: ${err.message}`);
    } finally {
      setLoading(null);
    }
  };

  const individualLessons = [
    { duration: "1 hour", price: 120, id: "1hr" },
    { duration: "30 minutes", price: 84, id: "30min" },
  ];

  const bundles = [
    { lessons: 4, price: 456, savings: 24, id: "4pack" },
    { lessons: 8, price: 864, savings: 96, id: "8pack" },
  ];

  const subscriptionBenefits = [
    "10% off 1 Hour Lessons",
    "20% off streamed Concerts",
    "$5 off Merch",
    "Full Access to music catalog",
    "Access to Monthly news letter",
    "Early Access to Drops on new products, services and music",
  ];

  const subscriptionBenefitsSecond = [
    "20% off 1 hour Lesson",
    "Unlimited Replays on lessons",
    "35% off music streamed concerts",
    "$5 off merch",
    "Full Access to Music",
    "Access to Monthly news letter",
    "You will be an Honorary member and you will get discounts off shows, upcoming events with chances to win Free Merch.",
    "Early Access to Drops on new products, services and music",
  ];

  const CheckIcon = () => (
    <svg className="checkmark" fill="currentColor" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        d="M16.847 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );

  return (
    <div className="packages-container">
      <div className="particles-bg">
        <div className="particle particle-1"></div>
        <div className="particle particle-2"></div>
        <div className="particle particle-3"></div>
        <div className="particle particle-4"></div>
      </div>
      <div className="gradient-overlay"></div>

      <div className="content-wrapper">
        <header className="header">
          <h1 className="main-title">Pricing</h1>
          <p className="subtitle">
            Elevate your musical journey with premium instruction tailored to
            your goals
          </p>
        </header>

        {/* Subscription Plans */}
        <section className="section subscription-section">
          <h2 className="section-title large">Subscription Plans</h2>
          <div className="subscription-grid">
            {/* Base Monthly */}
            <div className="pricing-card subscription-card">
              <div className="card-glow"></div>
              <div className="card-content">
                <div className="card-label">Base Subscription</div>
                <div className="subscription-price-wrapper">
                  <span className="subscription-price">$39</span>
                  <span className="subscription-period">/month</span>
                </div>
                <div className="benefits-list">
                  {subscriptionBenefits.map((benefit, idx) => (
                    <div key={idx} className="benefit-item">
                      <div className="benefit-icon">
                        <CheckIcon />
                      </div>
                      <span className="benefit-text">{benefit}</span>
                    </div>
                  ))}
                </div>
                <button
                  className="cta-button"
                  onClick={() => handleSubscribe("monthly")}
                  disabled={loading === "monthly"}
                  style={{ marginTop: "1.5rem", width: "100%" }}
                >
                  <span className="cta-text">
                    {loading === "monthly"
                      ? "Redirecting to Stripe..."
                      : "Subscribe — $39/mo"}
                  </span>
                  <div className="cta-glow"></div>
                </button>
              </div>
            </div>

            {/* VIP Yearly */}
            <div className="pricing-card subscription-card yearly">
              <div className="yearly-badge">VIP Subscription</div>
              <div className="card-glow"></div>
              <div className="card-content">
                <div className="card-label">Monthly </div>
                <div className="subscription-price-wrapper">
                  <span className="subscription-price">$79.99</span>
                  <span className="subscription-period">/month</span>
                </div>
                <div className="benefits-list">
                  {subscriptionBenefitsSecond.map((benefit, idx) => (
                    <div key={idx} className="benefit-item">
                      <div className="benefit-icon">
                        <CheckIcon />
                      </div>
                      <span className="benefit-text">{benefit}</span>
                    </div>
                  ))}
                </div>
                <button
                  className="cta-button"
                  onClick={() => handleSubscribe("yearly")}
                  disabled={loading === "yearly"}
                  style={{ marginTop: "1.5rem" }}
                >
                  <span className="cta-text">
                    {loading === "yearly"
                      ? "Redirecting to Stripe..."
                      : "Subscribe — $79.99/mo"}
                  </span>
                  <div className="cta-glow"></div>
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Individual Lessons */}
        <section className="section">
          <h2 className="section-title">Individual Lessons</h2>
          <div className="lessons-grid">
            {individualLessons.map((lesson) => (
              <div key={lesson.id} className="pricing-card">
                <div className="card-glow"></div>
                <div className="card-content">
                  <div className="card-label">{lesson.duration}</div>
                  <div className="card-price">${lesson.price}</div>
                  <div className="card-divider"></div>
                  <p className="card-description">
                    Perfect for focused, personalized instruction
                  </p>
                  <button
                    className="cta-button"
                    onClick={() => handleSubscribe(lesson.id)}
                    style={{ marginTop: "1rem", width: "100%" }}
                  >
                    <span className="cta-text">Book Now — ${lesson.price}</span>
                    <div className="cta-glow"></div>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Bundles */}
        <section className="section">
          <h2 className="section-title">Lesson Bundles</h2>
          <div className="lessons-grid">
            {bundles.map((bundle) => (
              <div key={bundle.id} className="pricing-card">
                <div className="savings-badge">SAVE ${bundle.savings}</div>
                <div className="card-glow"></div>
                <div className="card-content">
                  <div className="card-label">{bundle.lessons} Lessons</div>
                  <div className="card-price">${bundle.price}</div>
                  <div className="card-divider"></div>
                  <p className="card-description">
                    Commit to growth with significant savings
                  </p>
                  <button
                    className="cta-button"
                    onClick={() => handleSubscribe(bundle.id)}
                    style={{ marginTop: "1rem", width: "100%" }}
                  >
                    <span className="cta-text">
                      Buy Bundle — ${bundle.price}
                    </span>
                    <div className="cta-glow"></div>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Group Plan */}
        <section className="section">
          <div className="pricing-card group-card">
            <div className="card-glow"></div>
            <div className="card-content group-content">
              <h2 className="group-title">Group Plan</h2>
              <p className="group-subtitle">5 students or more</p>
              <div className="group-price-wrapper">
                <span className="group-price">$40</span>
                <span className="group-price-label">per student / hour</span>
              </div>
              <div className="group-divider"></div>
              <p className="card-description">
                Learn together, grow together — ideal for bands, ensembles, or
                study groups
              </p>
              <button
                className="cta-button"
                onClick={() => handleSubscribe("group")}
                style={{ marginTop: "1rem", width: "100%" }}
              >
                <span className="cta-text">Book Group Plan — $40/student</span>
                <div className="cta-glow"></div>
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Packages;
